/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {

    "use strict";

    export class SettingsLoanerAgreementSelectPageController {

        public static $inject : string[ ] = [ '$state', 'SettingsLoanerAgreementService' ];

        public active: boolean = true;

        constructor (
            private $state  : any,
            private service : any
        ) {

            // A hard reload for this state will run the API call(s) in SettingsLoanerAgreementController
            // and resolveLoanerAgreementState and so forth, so nothing need be done from here the attempted
            // load of this page itself.
            //
            // But if the agreement fetch has been tried already -- such as would happen if arriving at this
            // state was from a normal transition (button click) in the UI, or from clicking a bookmark --
            // then there will be a jump straight to the resolution code.
            //
            // Running the resolution code (resolveLoanerAgreementState) may result in the signature
            // API call being run, because that call is only done if an agreement is present.
            //
            // Of course, if there is a request to load a step in the process beyond what the user
            // is entitled to see, resolveLoanerAgreementState, will bounce the user back to the appropriate
            // page, either upload if no uploaded agreement exists, or view (reflecting the last step
            // completed) if it does.
            //
            if (this.service.getAgreementRun) {
                this.service.resolveLoanerAgreementState ($state, this.service.isUploaded())
            }
        }
    }

    getDealerwareWebContentModule().controller(
        'SettingsLoanerAgreementSelectPageController', SettingsLoanerAgreementSelectPageController
    );
}
